import { Component, OnInit } from '@angular/core';
import { MatSnackBarRef } from '@angular/material';

@Component({
  selector: 'unexpected-error',
  templateUrl: './unexpected-error.component.html',
  styleUrls: ['./unexpected-error.component.scss']
})
export class UnexpectedErrorComponent implements OnInit {

  constructor(private snackRef: MatSnackBarRef<UnexpectedErrorComponent>) { }

  dismiss () {
    this.snackRef.dismiss();
  }

  ngOnInit() {
  }

}
